module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_vm._m(0), _vm._v(" "), _vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Stacy Connelly\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "authorDescription body article"
  }, [_vm._v("Stacy Connelly dreamed of publishing books since she was a kid writing about a girl and her horse. Eventually, boys made it onto the page as she discovered a love of romance and the promise of happily-ever-after. "), _c('Br', [_c('Br', [_vm._v("In 2008, that dream came true when she sold All She Wants for Christmas to Silhouette Special Edition. "), _c('Br', [_c('Br', [_vm._v("When she is not lost in the land of make-believe, Stacy lives in Arizona with her two spoiled dogs.")])], 1)], 1)], 1)], 1)]), _vm._v(" "), _vm._m(2)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/Y1NQim/tc-custom/9781460343081.jpg?1740434171293",
      "alt": "This image is the cover for the book Romancing the Rancher, The Pirelli Brothers"
    }
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Romancing the Rancher, The Pirelli Brothers\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }), _c('p', [_vm._v("To Kiss a Cowboy "), _c('br'), _c('br'), _vm._v("Former rodeo star Jarrett Deeks knows about saving horses, but city women like Theresa Pirelli have always been out of his league. Yet her kiss rocks him harder than any bull he's ever ridden. In her, he sees himself: a little bruised, a lot lonely. She's his for only a few weeks, except unlike his horses, he can't let her go once she's healed. But how can he convince her to stay? "), _c('br'), _c('br'), _vm._v("Theresa is used to taking care of patientsnot being one! When an accident jeopardizes her career, she needs a break from worrying about her uncertain future and interfering family. A few weeks at Jarrett's rustic California horse ranch seem like just the ticket to get back on her feet. Until she's completely swept off them by one sexy cowboy.")]), _vm._v(" "), _c('p')])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Harlequin\n   ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5c3ee598","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0